const DashedLines = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="320"
      height="1"
      viewBox="0 0 320 1"
      fill="none"
    >
      <line
        x1="0.5"
        y1="0.5"
        x2="319.504"
        y2="0.5"
        stroke="#D6D6D6"
        stroke-dasharray="4 4"
      />
    </svg>
  );
};

export default DashedLines;
